import { useRef, useMemo } from 'react';
import { isEqual } from 'lodash-es';

/**
 * Custom hook to deeply memoize any value.
 * @param value - The data to be memoized.
 * @returns The deeply memoized value.
 */
function useDeepMemo<T>(value: T): T {
  // Reference to store the previous value
  const prevValueRef = useRef<T>(value);

  // Memoize the value if it has changed based on deep equality
  return useMemo(() => {
    if (!isEqual(prevValueRef.current, value)) {
      prevValueRef.current = value; // Update ref if value has changed
    }
    return prevValueRef.current; // Return memoized (or unchanged) value
  }, [value]);
}

export default useDeepMemo;
